// Single source of truth for mobility region labels + trend chart config.
// Imported by BOTH the /mobility page and the /performance (Movement) page so
// their region names and trend lines can never drift apart again.

export const REGION_DISPLAY = {
  shoulder_L:  'Left Shoulder',
  shoulder_R:  'Right Shoulder',
  spine_L:     'Side Bend L',
  spine_R:     'Side Bend R',
  core_lumbar: 'Lower Back / Core',
  hip_L:       'Left Hip',
  hip_R:       'Right Hip',
  ankle_L:     'Left Ankle',
  ankle_R:     'Right Ankle',
  neck_L:      'Neck Tilt L',
  neck_R:      'Neck Tilt R',
  // Legacy keys still present in older baselines (kept so old data isn't shown raw)
  thoracic_L:  'Trunk Rotation L (legacy)',
  thoracic_R:  'Trunk Rotation R (legacy)',
  knee_L:      'Left Knee (legacy)',
  knee_R:      'Right Knee (legacy)',
  thoracic:    'Trunk Rotation (legacy)',
  neck:        'Neck (legacy)',
};

// Friendly label for a region key (falls back to a humanised key).
export const regionLabel = (key) =>
  REGION_DISPLAY[key] || key.replace('_L', ' L').replace('_R', ' R').replace('_', ' ');

// The trend-chart series shared by both pages (order = legend order).
export const TREND_LINES = [
  { key: 'overall',   name: 'Overall',    color: '#CCFF00', strong: true },
  { key: 'shoulders', name: 'Shoulders',  color: '#60A5FA' },
  { key: 'hips',      name: 'Hips',       color: '#F472B6' },
  { key: 'ankles',    name: 'Ankles',     color: '#FB923C' },
  { key: 'neck',      name: 'Neck',       color: '#A78BFA' },
  { key: 'sideBend',  name: 'Side Bend',  color: '#34D399' },
  { key: 'lowerBack', name: 'Lower Back', color: '#FBBF24' },
];

// Build chart data from baseline history: each baseline → one dated point with
// overall + averaged joint-group scores (date-sorted ascending).
export const buildRegionTrend = (history = []) =>
  [...history]
    .sort((a, b) => new Date(a.taken_at) - new Date(b.taken_at))
    .map((h) => {
      const rs = h.region_scores || null;
      const avg2 = (a, b) => (rs ? Math.round(((rs[a] ?? 0) + (rs[b] ?? 0)) / 2) : null);
      return {
        date: new Date(h.taken_at).toLocaleDateString(undefined, { month: 'short', day: 'numeric' }),
        overall: h.overall_mobility,
        shoulders: avg2('shoulder_L', 'shoulder_R'),
        hips: avg2('hip_L', 'hip_R'),
        ankles: avg2('ankle_L', 'ankle_R'),
        neck: avg2('neck_L', 'neck_R'),
        sideBend: avg2('spine_L', 'spine_R'),
        lowerBack: rs ? (rs.core_lumbar ?? null) : null,
      };
    });
